<template>
	<div class="primary-nav-container">
		<header>
			<div class="hamburger-menu" v-on:click="toggleDirectory">
				<div v-for="i in 3" :key="'line' + i" class="hamburger-line"></div>
			</div>
			<img src="../assets/ahc-logo-white.png" alt="Atlanta History Center">
		</header>
		<TodaysEvents v-if="eventsToday === true" ref="todaysEvents" @selectEvent="selectEvent"/>
		<footer :class="[{ 'active': this.footerActive }]" v-on:click="onBackButton">
			<input type="image" :src="backSvg" id="back" role="button">
			<input type="image" :src="homeSvg" id="home" role="button" v-on:click="onHomeButton">
		</footer>
	</div>
</template>

<script>
	import TodaysEvents from '@/components/TodaysEvents.vue';

	export default {
		name: "PrimaryNav",
		components: {
			TodaysEvents
		},
		data: function() {
			return {
				sharedStore: window.store,
				backSvg: require('../assets/ui/back-icon.svg'),
				homeSvg: require('../assets/ui/home-icon.svg')
			}
		},
		computed: {
			footerActive: function() {
				// open footer with home/back button if either the directory or location overlay is visible
				return this.sharedStore.state.currentLocation.length > 0;
			},
			eventsToday: function() {
				return this.sharedStore.state.todaysEventsData 
					&& this.sharedStore.state.todaysEventsData.showTodaysEvents === true;
			}
		},
		methods: {
			onBackButton: function() {
				// back button retains map view and zoom, will re-open directory if necessary
				if (this.sharedStore.state.backButtonTarget === "directory") {
					this.sharedStore.setDirectoryOpen(true);
				} else {
					this.sharedStore.setDirectoryOpen(false);
				}

				if (this.sharedStore.state.backButtonTarget === "overlay") {
					this.$emit('closeEventCard');
				} else {
					this.sharedStore.setCurrentLocation("");
				}
				// always close out of a location if we are in there
				this.sharedStore.setBackTarget("");
			},
			onHomeButton: function() {
				if (this.sharedStore.state.backButtonTarget === "overlay") {
					this.$emit('closeEventCard');
				}
				// home button should reset current map view and zoom
				this.sharedStore.setDirectoryOpen(false);
				this.sharedStore.setBackTarget("");
				this.sharedStore.setCurrentLocation("");
				// reset map view based on current directory tab
				this.sharedStore.setCurrentMap("");
				let nextMapView = "gardens";
				if (this.sharedStore.state.directoryMap === "main") {
					nextMapView = "main"
				}
				// wait one tick to allow map changes to process and get picked up by the map component
				this.$nextTick(() => {
					this.sharedStore.setCurrentMap(nextMapView);
				});
			},
			toggleDirectory: function() {
				this.sharedStore.setDirectoryOpen(!this.sharedStore.state.directoryOpen);
				this.sharedStore.setCurrentLocation("");
				if (this.$refs.todaysEvents) {
					this.$refs.todaysEvents.hide();
				}
			},
			showTodaysEvents: function() {
				this.sharedStore.setDirectoryOpen(false);
				if (this.$refs.todaysEvents) {
					this.$refs.todaysEvents.show();
				}
			},
			hideTodaysEvents: function() {
				if (this.$refs.todaysEvents) {
					this.$refs.todaysEvents.hide();
				}
			},
			selectEvent: function(prefix) {
				this.$emit("selectEvent", prefix);
			}
		}
	};
</script>

<style scoped lang="scss">
	.primary-nav-container {
		position: fixed;
		height: 100%;
		width: 0;
	}

	header {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 70px;
		padding: 15px 0;
		background: rgb(25, 25, 25);
    display: flex;

		img {
			height: 40px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
		}

    .hamburger-menu {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 28px;
      justify-content: space-evenly;

      .hamburger-line {
        background: white;
        height: 4px;
        width: 40px;
        margin: 3px 0;
      }
    }
	}

  footer {
		position: fixed;
		bottom: 0;
		right: 0;
		width: 100%;
		display: flex;
		justify-content: space-between;
		background: rgb(25, 25, 25);
		transition: 0.5s;
		transform: translateY(100%);
		box-shadow: none;

		@media (min-aspect-ratio: 1/1) {
			width: 50%;
		}

		input {
			width: 96px;
			height: 80px;
			padding: 20px 28px;
			border: none;
			outline: none;
			cursor: pointer;

			transition: 0.2s;
			background-color: rgba(255, 255, 255, 0);
			background-clip: content-box;

			&:active {
				background-color: rgba(255, 255, 255, 0.5);
				transition: 0s;
			}
		}

		&.active {
			transition-delay: 0.5s;
			transform: translateY(0);
			box-shadow: 0px 0px 15px black;
		}
	}
  
	.kiosk {
		header {
			height: 170px;
			padding: 45px 0;
		}
	}
</style>
